import type { FaireProductEntity } from "../../entity_types/product";

export const p_296y7ghmeu: FaireProductEntity = {
  token: "p_296y7ghmeu",
  type: "product",
  name: "( F343 )  TWIST KNOT EARRING",
  brandToken: "b_r5aqp735w9",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/469243aa468f61c25f94a8ccd22447e04b7fbeae67319051a1426472ae59e7ac.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.99,
  description:
    "As Jewelry Max, we present the F343 Twist Knot Earring. A dangle earring with a unique twist knot design, measuring 7/8 x 7/8 inches. This exquisite piece embodies elegance, quality, and style, making it a perfect addition to any jewelry collection. Explore our stunning collection and let our pieces cater to all your style needs.",
  tags: [],
  msrpDollars: 13.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:14.289Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
